import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import HeroVisual from "@/components/HeroVisual";
import { PARTNERS } from "@/data/site";
import { Link } from "react-router-dom";
import { ArrowRight, Award, Handshake, Clock, Globe2, MapPin, Wrench, Shield, BadgeCheck } from "lucide-react";

const advantageIcons = [Award, Handshake, Clock, Globe2, MapPin, Wrench];

export default function Partners() {
  const advantages = [
    "Yetkili kurulum ve destek",
    "Orijinal ürün ekosistemi",
    "Uzun vadeli sürdürülebilirlik",
    "Global standartlarda hizmet",
    "Yerel uzmanlık ve hızlı teknik servis",
    "Entegrasyon ve danışmanlık desteği",
  ];

  return (
    <>
      <SEO title="İş Ortaklarımız — Pratik Teknoloji" description="Mikro, e-Logo, Flap, Mihsap, Kalfa, Akıllı Ticaret ve e-Güven yazılım iş ortaklıklarımız." />

      <PageHero
        badge="İş Ortaklarımız"
        title={<>Yetkili, güvenilir,</>}
        titleAlt="sürdürülebilir."
        subtitle="Pratik Bilişim Teknolojileri A.Ş. olarak, işletmelere sunduğumuz tüm çözümlerde yetkili, güvenilir ve sürdürülebilir iş ortaklıklarıyla çalışıyoruz. Türkiye'nin lider markalarının yanı sıra global teknoloji üreticileriyle iş birliği yaparak müşterilerimize güvenilir bir ürün ekosistemi sağlıyoruz."
        rightSlot={
          <HeroVisual
            accentColor="#007AFF"
            center={{ icon: <Handshake size={36} strokeWidth={1.6} />, topLabel: "Yetkili", bottomLabel: "İş Ortakları" }}
            cards={[
              { position: "tr", rotate: 4, delay: 0.4, color: "#FF3B30", icon: <BadgeCheck size={16} />, label: "Yetki", value: "7 marka", sub: "resmi iş ortağı" },
              { position: "ml", rotate: -5, delay: 0.55, color: "#34C759", icon: <Globe2 size={16} />, label: "Kapsam", value: "Global", sub: "marka ekosistemi" },
              { position: "br", rotate: 3, delay: 0.7, color: "#007AFF", icon: <Shield size={16} />, label: "Orijinal", value: "%100", sub: "ürün ve lisans garantisi" },
            ]}
          />
        }
      />

      {/* Partners — white for logo visibility */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {PARTNERS.map((p) => (
              <div
                key={p.slug}
                data-testid={`partner-full-${p.slug}`}
                className="group rounded-3xl bg-white border border-[#E5E5EA] p-8 hover:-translate-y-1 hover:border-[#0A0A0A] transition-all duration-300"
              >
                <div className="aspect-[3/2] rounded-2xl bg-[#FDFBF7] border border-[#E5E5EA] flex items-center justify-center p-8 mb-6">
                  <img src={p.logo} alt={p.name} className="max-h-full max-w-full object-contain grayscale opacity-80 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500" />
                </div>
                <h3 className="font-display text-2xl font-bold text-[#0A0A0A]">{p.name}</h3>
                <p className="mt-2 text-[#52525B] leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advantages — dark */}
      <section className="py-20 md:py-28 bg-[#0A0A0A] text-white border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-[#FF3B30] mb-4">Avantajlar</div>
          <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight max-w-3xl mb-12">İş ortaklıklarının size getirdikleri.</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {advantages.map((a, i) => {
              const Icon = advantageIcons[i] || Award;
              return (
                <div key={a} className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 hover:border-[#FF3B30]/50 hover:bg-white/[0.06] transition-all">
                  <div className="flex items-center justify-between mb-4">
                    <div className="h-11 w-11 rounded-xl flex items-center justify-center bg-[#FF3B30]/10 text-[#FF3B30] border border-[#FF3B30]/20">
                      <Icon size={20} strokeWidth={1.8} />
                    </div>
                    <div className="text-xs font-bold tracking-[0.25em] text-white/40">0{i + 1}</div>
                  </div>
                  <div className="font-display text-xl font-semibold text-white">{a}</div>
                </div>
              );
            })}
          </div>
          <div className="mt-12 text-center">
            <Link to="/iletisim" className="inline-flex items-center gap-2 rounded-full bg-[#FF3B30] text-white px-7 py-4 font-semibold hover:bg-white hover:text-[#0A0A0A] transition-colors">
              Teklif Al <ArrowRight size={18}/>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
